var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4395 5.86902C17.1971 5.30759 16.8474 4.79882 16.4102 4.3712C15.9727 3.94231 15.4568 3.60147 14.8907 3.36723C14.3037 3.12337 13.674 2.99855 13.0383 3.00001C12.1465 3.00001 11.2764 3.24422 10.5203 3.70551C10.3394 3.81585 10.1675 3.93705 10.0047 4.06911C9.8419 3.93705 9.67005 3.81585 9.48915 3.70551C8.73301 3.24422 7.8629 3.00001 6.97108 3.00001C6.3289 3.00001 5.70662 3.12302 5.11871 3.36723C4.55069 3.6024 4.03876 3.94067 3.59918 4.3712C3.16141 4.79834 2.8117 5.30723 2.56988 5.86902C2.31844 6.45332 2.19 7.07379 2.19 7.71235C2.19 8.31473 2.31301 8.94244 2.55722 9.58101C2.76163 10.1146 3.05468 10.6682 3.42914 11.2272C4.02248 12.1117 4.83832 13.0343 5.85134 13.9695C7.53005 15.5198 9.19248 16.5907 9.26303 16.6341L9.69176 16.9091C9.8817 17.0303 10.1259 17.0303 10.3158 16.9091L10.7446 16.6341C10.8151 16.5889 12.4757 15.5198 14.1563 13.9695C15.1693 13.0343 15.9851 12.1117 16.5785 11.2272C16.9529 10.6682 17.2478 10.1146 17.4504 9.58101C17.6946 8.94244 17.8176 8.31473 17.8176 7.71235C17.8194 7.07379 17.691 6.45332 17.4395 5.86902Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.9551b99a666258951934db1358255b27.svg";
export { ForwardRef as ReactComponent };